import { trackVideoEngagement } from '../videoUtils';

declare global {
    interface Window {
        YT: typeof YT;
        onYouTubeIframeAPIReady?: () => void;
    }
}

export function loadYouTubeAPI(onReady: () => void) {
    if (window.YT && window.YT.Player) {
        onReady();
        return;
    }

    const existingScript = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
    if (existingScript) {
        window.onYouTubeIframeAPIReady = onReady;
        return;
    }

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = onReady;
}

export function extractYouTubeVideoId(url: string): string | null {
    try {
        if (url.includes('youtube.com/watch')) {
            return new URL(url).searchParams.get('v');
        }
    } catch (e) {
        console.warn('Failed to parse YouTube URL:', e);
    }
    return null;
}

export function createPlaybackRateChangeHandler(videoUrl: string) {
    return (event: { target: YT.Player; data: number }) => {
        const rate = event.data;
        trackVideoEngagement('playback_rate', videoUrl, [], [rate]);
    };
}
